// import { INTERNAL_LANGUAGES } from '@/utils/constants/locale'

// export const INDEX_PAGE = '/index'

// export const INDEX_PAGES = INTERNAL_LANGUAGES.map((localeCode) => `/${localeCode}${INDEX_PAGE}`)

export const FSF_PAGE = [
  '/en/book-flight',
  '/de/fluge-buchen',
  '/et/broneerige-lend',
  '/lv/rezervet-biletes',
  '/lt/uzsakyti-skrydzius',
  '/ru/kupit-aviabilety',
  '/fi/varaa-lennot',
  '/uk/bronyujte-aviakvitki'
]

export const INDEX_PAGE_NAMES = [
  '/en/index',
  '/lv/index',
  '/ru/index',
  '/et/index',
  '/lt/index',
  '/de/index',
  '/fi/index',
  '/uk/index'
]

export const MMB_ROUTE_NAMES = [
  '/en/manage-my-booking',
  '/lv/mana-rezervacija',
  '/ru/upravlenie-bronirovaniem',
  '/et/halda-broneeringut',
  '/lt/mano-uzsakymai',
  '/de/buchung-verwalten',
  '/fi/hallitse-varausta',
  '/uk/keruvaty-bronyuvannyam'
]

export const CKI_ROUTE_NAMES = [
  '/en/check-in',
  '/lv/registresanas-lidojumam',
  '/ru/registraciya-na-rejs',
  '/et/lennule-registreerimine',
  '/lt/registracija-skrydziui',
  '/de/online-check-in',
  '/fi/lahtoselvitys',
  '/uk/online-reiestratsiia'
]

export const SELF_SERVICE_PORTAL_SLUG = 'self-service-portal'

export const SELF_SERVICE = [
  `/en/${SELF_SERVICE_PORTAL_SLUG}`,
  `/de/${SELF_SERVICE_PORTAL_SLUG}`,
  `/et/${SELF_SERVICE_PORTAL_SLUG}`,
  `/lv/${SELF_SERVICE_PORTAL_SLUG}`,
  `/lt/${SELF_SERVICE_PORTAL_SLUG}`,
  `/ru/${SELF_SERVICE_PORTAL_SLUG}`,
  `/fi/${SELF_SERVICE_PORTAL_SLUG}`,
  `/uk/${SELF_SERVICE_PORTAL_SLUG}`
]

export const POST_REQUEST_PAGES = [...FSF_PAGE]
export const SELF_SERVICE_POST_REQUEST_PAGES = [...SELF_SERVICE]
export const STATIC_PAGES = [...INDEX_PAGE_NAMES, ...FSF_PAGE, ...MMB_ROUTE_NAMES, ...CKI_ROUTE_NAMES, ...SELF_SERVICE]

export const SELF_SERVICE_OLD_PAGE = '/self-service'
export const MMB_RETRIEVE_PAGE = '/mmb/retrieve'
export const CKI_RETRIEVE_PAGE = '/checkin/upsell'
